/**
 * runsheetRowFacts — the rules for the facts line of a RunsheetList row.
 * The line states only what a driver can act on, so a zero balance and a plain PICKUP
 * are left out instead of printed as "$0" and "PICKUP" on every row.
 */

import type { RunsheetLine } from '@/types';

export type RowBadge = 'complete' | 'extra' | 'install';

export interface RowFacts {
  payment: string;
  /** Null when the balance is zero. */
  balance: { text: string; colour: 'red.8' | 'green.8' } | null;
  /** Null when the code is a plain PICKUP or the row's Badge already names it. */
  pickupCode: string | null;
}

function paymentType(invnum: number): string {
  if (invnum === 0) return 'PAYG';
  return invnum > 0 ? `${invnum} in advance` : 'On Acct';
}

function balance(accountbalance: number): RowFacts['balance'] {
  if (accountbalance === 0) return null;
  return accountbalance < 0
    ? { text: `$${-accountbalance} owing`, colour: 'red.8' }
    : { text: `$${accountbalance} credit`, colour: 'green.8' };
}

export function runsheetRowFacts(item: RunsheetLine, badge?: RowBadge): RowFacts {
  return {
    payment: paymentType(item.invnum),
    balance: balance(item.accountbalance),
    // The complete Badge says nothing about the code, so a completed stop keeps an unusual one.
    pickupCode:
      item.pickupcode === 'PICKUP' || badge === 'extra' || badge === 'install'
        ? null
        : item.pickupcode,
  };
}
